// Analytics v2 is the default; `?analytics-v1=true` switches to v1. Read once at page load, so the screen
// (components/App/App.jsx) and the store (reducers/index.js) always use the same version.
export const isAnalyticsV1 =
  new URLSearchParams(window.location.search).get("analytics-v1") === "true";
